import gsap from "@lib/gsap";
import { Scroll } from "@lib/scroll";

interface AccordionOptions {
  closedHeight?: string;
  openHeight?: string;
  activeColor?: string;
  inactiveColor?: string;
  hoverColor?: string;
}

export default function createAccordion(
  items: NodeListOf<Element> | Element[],
  options: AccordionOptions = {},
) {
  const {
    closedHeight = "2.1rem",
    openHeight = "auto",
    activeColor = "#fef7aa",
    inactiveColor = "#f1f1f1",
  } = options;
  const itemsArray = Array.from(items);
  let activeItem: Element | null = null;

  function init() {
    gsap.set(itemsArray, { height: closedHeight });
    open(itemsArray[0]);
  }

  init();

  function open(item: Element) {
    activeItem = item;
    gsap.to(item, { height: openHeight, onComplete: () => Scroll.resize() });
    item.querySelector(".g_large_dot")?.classList.add("is-open");
    const tab = item.querySelector(".at_item_tab");
    if (!tab) return;
    tab.classList.add("is-active");
  }

  function close(item: Element) {
    gsap.to(item, { height: closedHeight, onComplete: () => Scroll.resize() });
    item.querySelector(".g_large_dot")?.classList.remove("is-open");

    const tab = item.querySelector(".at_item_tab");
    if (!tab) return;
    tab.classList.remove("is-active");
  }

  function openAll() {
    itemsArray.forEach(open);
  }

  function closeAll() {
    itemsArray.forEach(close);
  }

  return { open, close, openAll, closeAll };
}
